import useEntryContent from './useEntryContent';
import info from '../queries/info';
import articleQueries from '../queries/articles';

const useInfoSinglePageContent = pathName =>
  useEntryContent(pathName, `${info}${articleQueries.article}`, true, false);

export default useInfoSinglePageContent;
